import React from 'react';
import SchemaTemplateAdmin from '../admin/SchemaTemplateAdmin';

/** 参数模板 (2026-09-12 从「Schema 管理」拆出, 归官方参数中心): param_schema 按 框架/设备/加工模式/加工类型 (2026-11-01). */
function ParamTemplateAdmin() {
    return <SchemaTemplateAdmin />;
}

export default ParamTemplateAdmin;
